<div
  *ngIf="
    context.flag &&
    context.activeTab === 'payment-complete' &&
    context.showCompletedPayments
  "
  style="overflow: hidden"
>
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.completePaymentsDtOptions"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.completePaymentsTheads">
          {{ thead }}
        </th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
